const StarIcon = ({ filled, size = 28 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={filled ? "#fdc62f" : "none"}
    stroke="#a2833c"
    strokeWidth="1.8"
    width={size}
    height={size}
    style={{ marginRight: '2px' }}
  >
    <polygon
      points="12 2 15.1 8.3 22 9.3 17 14.1 18.2 21 12 17.8 5.8 21 7 14.1 2 9.3 8.9 8.3 12 2"
      strokeLinejoin="round"
    />
  </svg>
);
export default StarIcon;